import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { product } from '../data/landing';
export function StickyOfferBar() {
  const [pastHero, setPastHero] = useState(false);
  const [offerVisible, setOfferVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setPastHero(window.scrollY > window.innerHeight * 0.7);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    const offer = document.getElementById('offer-details');
    const observer = offer ? new IntersectionObserver(([entry]) => setOfferVisible(entry.isIntersecting), {
      threshold: 0.05
    }) : null;
    if (offer && observer) observer.observe(offer);
    return () => {
      window.removeEventListener('scroll', onScroll);
      observer?.disconnect();
    };
  }, []);
  const show = pastHero && !offerVisible;
  return <AnimatePresence data-id="element-217" data-mp="3vn9xpcg4alca">
      {show && <motion.div initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-navy text-white shadow-[0_-10px_30px_rgba(20,33,61,0.25)]" data-id="element-218" data-mp="3vocolkdfwns7">
          <div className="mx-auto flex max-w-[1180px] items-center justify-between gap-4 px-4 py-3 md:px-8" data-id="element-219" data-mp="knc3jn7snog8">
            <div className="flex min-w-0 items-center gap-3" data-id="element-220" data-mp="18d6ge4s45d0h">
              <img src={product.mockup} alt="" className="hidden h-12 w-8 shrink-0 rounded object-cover sm:block" data-id="element-221" data-mp="18dpwdfy7drbv" />
              <div className="min-w-0" data-id="element-222" data-mp="1cgcjx4nucq39">
                <p className="truncate font-display text-lg font-bold uppercase leading-tight md:text-xl" data-id="element-223" data-mp="ynwlkh5vxg8o">
                  {product.name}
                </p>
                <p className="text-xs text-white/70 md:text-sm" data-id="element-224" data-mp="13jv6fus08g4c">
                  12 meetings + 5 bonuses ·{' '}
                  <b className="text-amber" data-id="element-225" data-mp="1w28vb4vd4rra">
                    ${product.price} {product.currency}
                  </b>
                </p>
              </div>
            </div>
            <a href="#offer-details" className="shrink-0 whitespace-nowrap rounded-lg bg-amber px-4 py-2.5 text-sm font-bold uppercase text-navy shadow-[0_4px_0_#C48A1E] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-amber-hover active:translate-y-0.5 active:shadow-[0_2px_0_#C48A1E] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber md:px-6 md:text-base" data-id="element-226" data-mp="25w507bnv1czb">
              See the offer
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}